import type { PlatformSettings } from "../models/platform-settings.model";

const now = () => new Date().toISOString();

export const DEFAULT_PLATFORM_SETTINGS: PlatformSettings = {
  defaultTrialDays: 3,
  tenantCreationPolicy: "open",
  updatedAt: now(),
};
